// API
export const API = process.env.REACT_APP_LIFE_API_DEPLOYMENT;
// export const API = process.env.REACT_APP_LIFE_API;
